/* eslint-disable react-hooks/exhaustive-deps */
import { Grid2, Snackbar } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import CommonAlert from '../../components/CommonAlert'
import { SnackBarProps } from '../../components/Device-table/Provisioning'
import SettingLeftSidebar from '../../components/SettingLeftSidebar'
import { BreadcrumbContext } from '../../contexts/BreadcrumbContext'
import AnimatedLayout from '../../Layouts/AnimatedLayout'
import { getColorCode } from '../../utils/helper'
import PageNotFound from '../PublicPage/PageNotFound'
import NotificationPage from './NotificationPage'

const NotificationMainPage = () => {
  const [snackBarInfo, setSnackBarInfo] = useState<SnackBarProps>({
    isOpen: false,
    message: '',
    type: 'Closed'
  })
  const { updateBreadcrumbData } = useContext(BreadcrumbContext)
  const [selectedOptionId, setSelectedOptionId] = useState(1)
  const location = useLocation()
  const { id } = location.state?.data || {}

  useEffect(() => {
    updateBreadcrumbData([
      { label: 'Home', href: `/dashboard` },
      {
        label: 'Notifications',
        href: '/notifications'
      }
    ])
  }, [])

  if (!id) {
    return <PageNotFound />
  }

  return (
    <AnimatedLayout>
      <Snackbar
        open={snackBarInfo.isOpen}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={() =>
          setSnackBarInfo({
            isOpen: false,
            message: snackBarInfo.message,
            type: snackBarInfo.type
          })
        }
        sx={{ backgroundColor: 'transparent' }}
      >
        <div>
          <CommonAlert
            severity={snackBarInfo.type === 'redToRed' ? 'error' : 'success'}
            sx={{ color: getColorCode('white'), background: getColorCode(snackBarInfo.type) }}
          >
            {snackBarInfo.message}
          </CommonAlert>
        </div>
      </Snackbar>
      <Grid2 container rowSpacing={1} sx={{ height: '100%', width: '100%' }}>
        <Grid2 size={{ sm: 12, lg: 2, md: 3 }} sx={{ width: '100%' }}>
          <SettingLeftSidebar setSelectedOptionId={setSelectedOptionId} />
        </Grid2>
        <Grid2 size={{ sm: 12, lg: 10, md: 9 }}>
          {selectedOptionId === 1 && <NotificationPage setSnackBarInfo={setSnackBarInfo} />}
        </Grid2>
      </Grid2>
    </AnimatedLayout>
  )
}

export default NotificationMainPage
